module.exports = new __parcel__URL__("battlepass_buy_button_glfhers.e432c48b.png").toString();